import { render, staticRenderFns } from "./create_type.vue?vue&type=template&id=fa22ccce&scoped=true"
import script from "./create_type.vue?vue&type=script&lang=js"
export * from "./create_type.vue?vue&type=script&lang=js"
import style0 from "./create_type.vue?vue&type=style&index=0&id=fa22ccce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa22ccce",
  null
  
)

export default component.exports